export default __webpack_public_path__ + "static/media/activity_2.7b1372fa.png";